module.exports = __webpack_public_path__ + "img/sleeve armhole back.82f098fd.png";